import React, {forwardRef, useEffect, useState} from 'react'
import {TwCircle, TwSwitch, TwSwitchWrapper, TwText} from './containers'
import {SwitcherProps} from './types'

// Иногда из-за нескольких запросов пользователя формируется очередь
//  и не сразу отправляется, поэтому такое большое значение
const delayToCheck = 7_000

export const Switcher = forwardRef<HTMLElement, SwitcherProps>((props, ref) => {
  const {active = false, disabled = false, onClick, className, title} = props

  return (
    <TwSwitchWrapper
      ref={ref}
      $disabled={disabled}
      className={className}
      onClick={disabled ? undefined : onClick}
    >
      <TwSwitch
        $active={active}
        $disabled={disabled}
        data-test-id={props['data-test-id']}
      >
        <TwCircle $active={active} $disabled={disabled} />
      </TwSwitch>
      {title && <TwText $disabled={disabled}>{title}</TwText>}
    </TwSwitchWrapper>
  )
})

export const UncontrolledSwitcher = (props: SwitcherProps) => {
  const {onClick, active, ...rest} = props

  const [localActive, setLocalActive] = useState<boolean>(!!active)

  const click = (event: React.MouseEvent<HTMLDivElement>) => {
    setLocalActive(x => !x)
    onClick?.(event)
  }

  useEffect(() => setLocalActive(active), [active])

  return <Switcher active={localActive} onClick={click} {...rest} />
}

export const WaitingSwitcher = (props: SwitcherProps) => {
  const {onClick, active, ...rest} = props

  const [intermediateState, setIntermediateState] = useState<boolean>(!!active)

  const clickHandler = (event: React.MouseEvent<HTMLDivElement>) => {
    setIntermediateState(!intermediateState)
    onClick?.(event)
  }

  useEffect(() => {
    const tm = setTimeout(() => {
      if (!!active !== intermediateState) {
        setIntermediateState(!!active)
      }
    }, delayToCheck)

    return () => clearTimeout(tm)
  }, [intermediateState, active])

  return (
    <Switcher active={intermediateState} onClick={clickHandler} {...rest} />
  )
}
